
export const dummyData = {
    projectName: "Vedic Lifestyle",
    dummyProjects: [
        { label: "Vedic Lifestyle", value: "p1" }
    ],
    lastUpdated: "6.55pm",
    date: "12 Feb 2026",
    monthlyProgress: {
        planned: 78,
        actual: 72,
        variance: -6,
        delayDays: 8,
        executionScore: 82
    },
    stageProcess: [
        { name: "Foundation", planned: 100, actual: 100, color: "#1F4B55" },
        { name: "Structural", planned: 85, actual: 75, color: "#1F4B55" },
        { name: "MEP Rough- in", planned: 85, actual: 60, color: "#E3C86F" },
        { name: "Interior Walls", planned: 45, actual: 40, color: "#7FA0A5" },
        { name: "Finishes", planned: 30, actual: 15, color: "#E3C86F" },
        { name: "External Works", planned: 10, actual: 5, color: "#FF7676" },
    ],
    nextMonthFocus: [
        "Accelerate exterior facade completion with additional crew",
        "Secure interior finishes materials early",
        "Coordinate MEP final connections"
    ],
    monthlyInsights: "Project is 6% behind schedule but maintaining quality standards; additional resources allocated to critical path items.",
    keyDelays: [
        {
            id: 1,
            title: "Exterior Facade",
            reason: "Material delivery delay",
            responsible: "Vendor - ABC Glass",
            days: 12
        },
        {
            id: 2,
            title: "Electrical Cable Routing",
            reason: "Late delivery of LV panels",
            responsible: "Supplier - PowerTech",
            days: 6
        },
    ]
};
